<script setup lang="ts">
defineProps<{
  title: string
}>()
</script>
<template>
  <h1 class="tw-w-full tw-text-2xl tw-font-medium">
    {{ title }}
  </h1>
</template>
